import { BaseModel, IModel } from "../../../../core/util/BaseModel";

export interface IProjectInfoCardModel extends IModel {
  project: FP.Entities.IProject;
}

export class ProjectInfoCardModel extends BaseModel implements IProjectInfoCardModel {
  project: FP.Entities.IProject | any;
}
